import { render, staticRenderFns } from "./ReactionInputContent.vue?vue&type=template&id=490dc794&lang=pug&"
import script from "./ReactionInputContent.vue?vue&type=script&lang=js&"
export * from "./ReactionInputContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports